<box>
  <app-header [title]="'ship_interface.enter_inventory_rob' | transloco" [onBack]="onBack" [hasBottomBorder]="true"></app-header>
  <div class="border-b border-[#CBD7DF] py-6">
    <subtitle-block [title]="'ship_interface.fuel_oil_rob' | transloco"></subtitle-block>
    <div class="flex flex-row gap-2 px-9 py-3">
      <textbox
        class="w-full"
        [label]="'ship_interface.hfo_vlsfo' | transloco"
        [required]="true"
        [unit]="'ship_interface.mt' | transloco"
        [placeholder]="'0.00'"
        type="number"
        [control]="form?.get('rob_hfo')"
        [isDecimal]="true"
        [decimal]="2"></textbox>
      <textbox
        class="w-full"
        [label]="'ship_interface.mgo_lsmgo' | transloco"
        [required]="true"
        [unit]="'ship_interface.mt' | transloco"
        [placeholder]="'0.00'"
        [control]="form?.get('rob_mgo')"
        type="number"
        [isDecimal]="true"
        [decimal]="2"></textbox>
    </div>
  </div>
  <div class="border-b border-[#CBD7DF] py-6">
    <subtitle-block [title]="'ship_interface.lube_oil' | transloco"></subtitle-block>
    <div class="flex flex-row gap-2 px-9 py-3">
      <textbox
        class="w-full"
        [label]="'ship_interface.me_cyl' | transloco"
        [required]="true"
        [unit]="'ship_interface.l' | transloco"
        [placeholder]="'0.00'"
        type="number"
        [control]="form?.get('rob_luboil_me_cyl')"
        [isDecimal]="true"
        [decimal]="2"></textbox>
      <textbox
        class="w-full"
        [label]="'ship_interface.me_sys' | transloco"
        [required]="true"
        [unit]="'ship_interface.l' | transloco"
        [placeholder]="'0.00'"
        type="number"
        [control]="form?.get('rob_luboil_me_sys')"
        [isDecimal]="true"
        [decimal]="2"></textbox>
      <textbox
        class="w-full"
        [label]="'ship_interface.ge_sys' | transloco"
        [required]="true"
        [unit]="'ship_interface.l' | transloco"
        [placeholder]="'0.00'"
        type="number"
        [control]="form?.get('rob_luboil_ge_sys')"
        [isDecimal]="true"
        [decimal]="2"></textbox>
    </div>
  </div>
  <div class="py-6">
    <subtitle-block [title]="'ship_interface.fresh_water' | transloco"></subtitle-block>
    <div class="flex flex-row gap-2 px-9 py-3">
      <textbox
        class="w-full"
        [label]="'ship_interface.fw_fresh_water' | transloco"
        [required]="true"
        [unit]="'ship_interface.mt' | transloco"
        [placeholder]="'0.00'"
        type="number"
        [control]="form?.get('rob_freshwater')"
        [isDecimal]="true"
        [decimal]="2"></textbox>
    </div>
  </div>
  <app-footer [hasDiscardButton]="true" (discard)="onBack()" [hasTopBorder]="true" [onSave]="onSave" [disabledSaveButton]="form.invalid"></app-footer>
</box>
